<template>
    <HomeOverlay>
        <div class="h-100 f f-center-center t-h1">
            <SpinnerIcon />
        </div>
    </HomeOverlay>
</template>
